import React from 'react';

export class Slide extends React.PureComponent {
    render() {
        return (
            <div className="slide-container">
                <div className="slide">{this.props.children}</div>
            </div>
        );
    }
}
